
import "./Servicios.scss";

function Servicios({
  titulo = "Elegí el servicio que necesita tu negocio",
  subtitulo = "",
  etiqueta = "SERVICIOS",
  servicios = [],
  background = "#f7f7f8",
  colorh2 = "#555555",
  colorp = "#777",
  tag = "",
}) {

  const handleWhatsApp = (servicio) => {
    const mensaje = `Hola, quiero consultar por el servicio ${servicio.nombre}.`;

    window.open(
      `https://wa.me/5492954396316?text=${encodeURIComponent(mensaje)}`,
      "_blank"
    );
  };

  return (
    <section
      className="servicios"
      id="servicios"
      style={{
        "--servicios-background": background,
      }}
    >

      <div className="servicios-container">

        <div className="servicios-header">

          <span className="servicios-tag"
               style={{
        "--servicios-tag": tag,
      }}>
            {etiqueta} 
          </span>

          <h2 className="servicios-h2"
          style={{
        "--servicios-h2": colorh2,
      }}>{titulo}</h2>

          {subtitulo && (
            <p className="servicios-p"
               style={{
        "--servicios-p": colorp,
      }}>{subtitulo}</p>
          )}

        </div>

        <div className="servicios-grid">

          {servicios.map((servicio) => (

            <article
              key={servicio.id}
              className={`servicio-card ${
                servicio.destacado
                  ? "servicio-destacado"
                  : ""
              }`}
              style={{
                "--servicio-color":
                  servicio.color || "#891594",
              }}
            >

              {servicio.badge && (
                <div className="servicio-badge">
                  {servicio.badge}
                </div>
              )}

              <div className="servicio-top">

                <span className="servicio-dot">
                  ●
                </span>

                <h3>
                  {servicio.nombre}
                </h3>

              {/**  <div className="servicio-precio">
                  {servicio.precio}
                </div>*/} 

                <p className="servicio-descripcion">
                  {servicio.descripcion}
                </p>
              {servicio.etapas && (
                  <div className="servicio-proceso">

                    {servicio.etapas.map((etapa, index) => (
                      <div
                        className="servicio-etapa"
                        key={index}
                      >

                        <div className="etapa-contenido">

                          <strong>
                            {etapa.titulo}
                          </strong>
                          <span>  </span>
                          <span>
                            {etapa.descripcion}
                          </span>

                        </div>

                        {index < servicio.etapas.length - 1 && (
                          <span className="etapa-flecha">
                            ↓
                          </span>
                        )}

                      </div>
                    ))}

                  </div>
                )}
              </div>

              <div className="servicio-linea" />

              <ul className="servicio-lista">

                {servicio.items.map((item, index) => (

                  <li key={index}>

                    <span className="check">
                      ✓
                    </span>

                    <span>
                      {item}
                    </span>

                  </li>

                ))}

              </ul>

              <button
                className="servicio-button"
                onClick={() =>
                  handleWhatsApp(servicio)
                }
              >
                {servicio.boton ||
                  "QUIERO ESTE SERVICIO"}

                <span>→</span>
              </button>

            </article>

          ))}

        </div>

      </div>

    </section>
  );
}

export default Servicios;

